import type { MembershipTier } from '@fourthwall/services/dist/MembershipsApiClient'

export const getMapFromTierIds = (
  tierIds: string[],
  availableTiers: MembershipTier[] = [],
): Record<string, boolean> =>
  availableTiers.reduce((acc, tier) => {
    return {
      ...acc,
      [tier.id]: tierIds.indexOf(tier.id) !== -1,
    }
  }, {})

export const getTierIdsFromMap = (tierIdsMap: Record<string, boolean>): string[] =>
  Object.keys(tierIdsMap).reduce(
    (accumulator: string[], key) => (tierIdsMap[key] ? [...accumulator, key] : accumulator),
    [],
  )
